import { Reveal, Eyebrow } from "./Reveal";

const ABSTRACT_IMG =
  "https://images.unsplash.com/photo-1480944657103-7fed22359e1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxkYXJrJTIwZmluYW5jaWFsJTIwc2t5c2NyYXBlciUyMGdsYXNzJTIwcmVmbGVjdGlvbiUyMGFyY2hpdGVjdHVyZSUyMG5pZ2h0JTIwYWJzdHJhY3R8ZW58MHx8fHwxNzkzMzg4NjUwfDA&ixlib=rb-4.1.0&q=85";

const PILLARS = [
  {
    stat: "Integrity",
    title: "Financial Integrity",
    desc: "Safeguarding institutions against non-compliance penalties, enforcement action and financial crime such as money laundering and fraud.",
  },
  {
    stat: "Protection",
    title: "Consumer Protection",
    desc: "Building robust operational resilience and client-safety standards that hold up under regulatory scrutiny.",
  },
  {
    stat: "Proactive",
    title: "Risk Management",
    desc: "Mitigating systemic, conduct and regulatory risk before it triggers intervention — not after.",
  },
  {
    stat: "Trust",
    title: "Reputation & Client Trust",
    desc: "Transparent compliance builds confidence with boards, regulators and partners — and attracts clients who value strong compliance records.",
  },
];

export default function WhyCompliance() {
  return (
    <section id="why" data-testid="why-compliance-section" className="relative py-28 px-6 overflow-hidden bg-white">
      <div className="absolute inset-0 -z-0">
        <img src={ABSTRACT_IMG} alt="" aria-hidden="true" className="w-full h-full object-cover opacity-[0.06]" />
        <div className="absolute inset-0 bg-gradient-to-b from-white via-white/80 to-white" />
      </div>

      <div className="relative max-w-7xl mx-auto">
        <Reveal className="max-w-2xl mb-16">
          <Eyebrow>Why It Matters</Eyebrow>
          <h2 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl text-[#1b2a4e] tracking-tight leading-[1.1]">
            Compliance is not a cost centre. <span className="italic text-[#a8824f]">It is a competitive asset.</span>
          </h2>
          <p className="text-[#45506b] mt-5 text-sm sm:text-base leading-relaxed">
            Adherence to the laws, regulations and guidelines governing financial services keeps
            operations lawful, avoids costly fines and reputational harm — and protects the consumers
            who trust your firm.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PILLARS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.08}>
              <div
                data-testid={`pillar-${p.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group h-full p-7 rounded-2xl bg-white border border-[#e6e1d5] hover:border-[#a8824f]/60 hover:shadow-[0_20px_50px_rgba(27,42,78,0.1)] transition-all duration-300"
              >
                <span className="font-mono-alt text-[11px] uppercase tracking-[0.3em] text-[#a8824f] block mb-6">
                  {p.stat}
                </span>
                <span className="block h-px w-10 bg-[#a8824f] mb-6 group-hover:w-16 transition-all duration-500" />
                <h3 className="font-display text-xl text-[#1b2a4e] mb-3">{p.title}</h3>
                <p className="text-sm text-[#45506b] leading-relaxed">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
